import React, { useContext, useEffect, useState, useMemo } from 'react'
import { Link } from 'react-router-dom'
import ReactSelect from 'react-select'

import { UserContext } from '../../wrappers/UserContext'
import { checkRole, getAgencyCode } from '../../../utils/user/permissions'
import { DataContext } from './DataContext'
import LoadingWrapper from '../../wrappers/LoadingWrapper'
import urls, { createSubmissionUrl } from '../../../utils/constants/urls'
import Breadcrumbs from './form/Breadcrumbs'
import { useParams } from 'react-router-dom/cjs/react-router-dom.min'

const DEFAULT_AGENCY_CODE = 'WYDEQ'

const AgencyMessage = ({ agency }) => (
    <div className="column is-7">Submitting results as {agency.AgencyName}</div>
)

const FormReviewerSelection = ({ agencies, setAgencyCode }) => {
    const options = agencies.map(agency => ({
        label: agency.AgencyName,
        value: agency.AgencyCode,
    }))

    return (
        <div className="column is-7">
            Please select an organization to submit for:
            <div className="">
                <ReactSelect
                    className="select is-multiple is-small is-multiple is-fullwidth reactSelect"
                    classNamePrefix="reactSelect"
                    options={options}
                    menuPlacement="auto"
                    isClearable
                    onChange={option => setAgencyCode(option ? option.value : null)}
                />
            </div>
        </div>
    )
}

const ContinueButton = ({ onClick }) => (
    <div className="button is-link is-medium" onClick={onClick}>
        Continue
    </div>
)

const CancelButton = () => {
    const { type } = useParams()
    const { formTypes } = useContext(DataContext)
    const formType = useMemo(
        () => formTypes && formTypes.find(x => x.Link === type),
        [formTypes, type]
    )
    const uploadDialogueUrl = useMemo(
        () =>
            formType && formType.ShowSelectionDialogue
                ? createSubmissionUrl(urls.uploadDialogue, type)
                : urls.uploadSelectionDialogue,
        [formType, type]
    )
    return (
        <Link to={uploadDialogueUrl}>
            <div className="button is-medium">Back</div>
        </Link>
    )
}

export default ({ onSubmit }) => {
    const { roles } = useContext(UserContext)
    const { agencies } = useContext(DataContext)
    const [agencyCode, setAgencyCode] = useState(getAgencyCode(roles))
    const [submit, setSubmit] = useState(false)
    const [isFormReviewer, setIsFormReviewer] = useState(
        checkRole('Form_Reviewer', roles)
    )
    const [selectedAgency, setSelectedAgency] = useState()

    useEffect(() => {
        setAgencyCode(getAgencyCode(roles))
        setIsFormReviewer(checkRole('Form_Reviewer', roles))
    }, [roles])

    useEffect(() => {
        if (agencies && agencyCode) {
            setSelectedAgency(
                agencies.find(agency => agency.AgencyCode === agencyCode)
            )
        }
    }, [agencyCode, agencies])

    useEffect(() => {
        if (submit) {
            onSubmit(agencyCode || DEFAULT_AGENCY_CODE)
        }
    }, [submit, agencyCode])

    return (
        <div className="hero is-fullheight-with-navbar">
            <Breadcrumbs />
            <div className="hero-body">
                <div className="container">
                    <div className="section">
                        <div className="columns is-centered is-multiline">
                            <LoadingWrapper data={agencies}>
                                <FormReviewerSelection
                                    agencies={agencies}
                                    setAgencyCode={setAgencyCode}
                                />
                                <div className="column is-7 is-centered buttonWrapper">
                                    <ContinueButton
                                        onClick={() => setSubmit(true)}
                                    />
                                    <CancelButton />
                                </div>
                            </LoadingWrapper>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
